export const  sliderItems = 
[
  {
  id: 1,
  img: "1.webp",
  title:"تشكيلة حديثة",
  desc: "لا تتنازل عن الأناقة! احصل على خصم ثابت بنسبة 30% على المنتجات الجديدة.",
  bg: "f5fefd"
  },
  {
    id: 2,
    img: "2.jpg",
    title: "تشكيلة مخفضة",
    desc: "لا تتنازل عن الأناقة! احصل على خصم ثابت بنسبة 50% على المنتجات الجديدة.",
    bg: "fcf1ed"
    },

]

export const categories = [
{
  id: 1,
  img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRC1BHgox6ZCoziWhW3472AKI70abzPbnnglP4rvfcxXsusjRB_Kkpw3DY&s",
  title: "رجالي",
  cat: "men"
},
{
  id: 2,
  img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRA1TcJa3p4Z5rQ8oS8cQEJ6pWyALKO3cLgb73CmHiNYZDl86VnXf6ZviA&s",
  title: "نسائي",
  cat: "women"
},
{
  id: 3,
  img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT0LGmm_onTbOHCSMxfcJJnw__9EsqSe8qFCA&s",
  title: "أطفال",
  cat: "children"
},

]

export const popularProducts = [

  {
    id: 1,
    img: "cat1.png"
  },
  {
    id: 2,
    img: "men-golf-polo-t-shirt-black.png"
  },
  {
    id: 3,
    img: "men-golf-polo-t-shirt-black.png"
  },
  {
    id: 4,
    img: "men-golf-polo-t-shirt-black.png"
  },
  {
    id: 5,
    img: "men-golf-polo-t-shirt-black.png"
  },
  
]